import React from 'react';
import Navigation from '../Navigation';
import { Button } from '../ui/button';
import { Card, CardContent, CardHeader, CardTitle, CardDescription } from '../ui/card';
import { Play, Stethoscope } from 'lucide-react';

const VioConciergeTest = () => {
  const handleDemo = () => {
    window.open('https://cal.com/concierge/vioqbase-demo', '_blank');
  };

  return (
    <div className="min-h-screen bg-white font-sans">
      <Navigation />
      
      {/* Hero Section */}
      <section className="relative bg-gradient-to-br from-[#112d56] via-[#1a3d6b] to-[#112d56] text-white overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-white/5 to-transparent"></div>
        <div className="relative container mx-auto px-6 py-20 lg:py-32">
          <div className="max-w-6xl mx-auto text-center">
            <div className="space-y-6 lg:space-y-8">
              <h1 className="text-4xl lg:text-6xl xl:text-7xl font-bold leading-tight tracking-tight">
                TEST PAGE - Reduce Your Missed <span className="text-[#ff7a1f]">Client Appointments</span>
              </h1>
              <p className="text-xl lg:text-2xl text-blue-100 leading-relaxed max-w-5xl mx-auto">
                This is a test page to debug the rendering issue.
              </p>
              
              <div className="flex flex-col sm:flex-row gap-4 justify-center items-center pt-8">
                <Button 
                  onClick={handleDemo}
                  size="lg"
                  className="bg-[#ff7a1f] hover:bg-[#e6681b] text-white font-semibold px-8 py-6 text-lg rounded-xl transition-all duration-300 transform hover:scale-105 hover:shadow-xl"
                >
                  <Play className="mr-3 h-6 w-6" />
                  Try VioConcierge Live Demo
                </Button>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Test Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="max-w-7xl mx-auto">
            <div className="text-center mb-16">
              <h2 className="text-4xl lg:text-5xl font-bold text-[#112d56] mb-6">
                Test Section - Is Perfect For Every <span className="text-[#ff7a1f]">Appointment-Based Business</span>
              </h2>
              <p className="text-xl text-gray-600 leading-relaxed max-w-4xl mx-auto">
                This section should render if the issue is not with the Card components
              </p>
            </div>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8">
              
              {/* Test Card */}
              <Card className="border-0 shadow-lg hover:shadow-xl transition-all duration-300 group bg-gradient-to-br from-white to-gray-50">
                <CardHeader className="pb-4">
                  <div className="w-16 h-16 bg-gradient-to-br from-blue-500/20 to-blue-500/5 rounded-2xl flex items-center justify-center mx-auto mb-6 group-hover:scale-110 transition-transform duration-300">
                    <Stethoscope className="h-8 w-8 text-blue-600" />
                  </div>
                  <CardTitle className="text-xl font-bold text-[#112d56] text-center mb-4">Test Medical Practices</CardTitle>
                  <CardDescription className="text-gray-600 text-center leading-relaxed">
                    This is a test card to see if the issue is with the Card components or something else.
                  </CardDescription>
                </CardHeader>
              </Card>

            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="bg-[#112d56] text-white py-16">
        <div className="container mx-auto px-6">
          <div className="text-center">
            <p className="text-blue-200 text-lg">
              © 2025 VioQbase Test Page. All rights reserved.
            </p>
          </div>
        </div>
      </footer>
    </div>
  );
};

export default VioConciergeTest;